import Axios from "axios";

export const SelectNomenclatureCS = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=CS&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "NOMENCLATURECS_SELECT",
        payload: response.data,
      });
    });
  };
};
